import {ProductSubscriptionLifecycleStatus} from 'src/openapi/admin/models/ProductSubscriptionLifecycleStatus';

export const LIFECYCLE_STATUS_OPTIONS = [
    [ProductSubscriptionLifecycleStatus.ACTIVE, 'Active'],
    [ProductSubscriptionLifecycleStatus.PENDING, 'Pending'],
    [ProductSubscriptionLifecycleStatus.EXPIRED, 'Expired'],
    [ProductSubscriptionLifecycleStatus.CANCELLED, 'Cancelled'],
] as const;

export const COLUMNS = [
    {columnId: 'product', caption: 'Product', width: 500, minWidth: 320, maxWidth: 600},
    {columnId: 'status', caption: 'Status', width: 80, minWidth: 80, maxWidth: 160},
    {columnId: 'sourceRefs', caption: 'Contract ID', width: 400, minWidth: 300, maxWidth: 650},
    {columnId: 'startDate', caption: 'Start Date', width: 150, minWidth: 150, maxWidth: 300},
    {columnId: 'endDate', caption: 'End Date', width: 150, minWidth: 150, maxWidth: 300},
    {columnId: 'seats', caption: 'Seats', width: 170, minWidth: 120, maxWidth: 360},
    {columnId: 'source', caption: 'Source', width: 100, minWidth: 100, maxWidth: 280},
    {columnId: 'action', caption: 'Action', width: 90, minWidth: 90, maxWidth: 120},
] as const;
